/* eslint-disable react/react-in-jsx-scope */
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import MuiTimelineConnector from "@material-ui/lab/TimelineConnector";
import MuiTimelineContent from "@material-ui/lab/TimelineContent";
import MuiTimelineDot from "@material-ui/lab/TimelineDot";
import MuiTimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { format } from "date-fns";
import { Axe, EActionType, Stop as StopType, Task, TaskMission } from "generated/graphql";
import styled from "styled-components";

export const TimelineItem = styled(MuiTimelineItem)`
  min-height: 30px;
  margin-left: 10px;
  justify-content: space-between;
  &.dot {
    min-height: 20px;
  }
  :before {
    content: none;
  }
`;

const ActivityTriggerActionT = {
  STARTED: {
    color: "#399ebf",
    backgroundColor: "#b6ddea",
  },
  ASSIGNED: {
    color: "#fff",
    backgroundColor: "#ffcf5a",
  },
  UNASSIGNED: {
    color: "#399ebf",
    backgroundColor: "#fff",
    borderColor: "#399ebf",
  },
  DEFAULT: {
    color: "#399ebf",
    backgroundColor: "#fff",
    borderColor: "#399ebf",
  },
  DONE: {
    color: "#fff",
    backgroundColor: "#33d413",
    borderColor: "#33d413",
  },
};
interface ActivityTriggerActionEnumStyle {
  color: string;
  backgroundColor: string;
  borderColor?: string;
}
export const DivStatus = styled.div`
  font-size: 12px;
  font-weight: 500;
  width: auto;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  text-align: center;
  padding-left: 6px;
  padding-right: 6px;
  border: ${(props: ActivityTriggerActionEnumStyle = ActivityTriggerActionT.DEFAULT) =>
    `${props?.borderColor} 1px solid` || "none"};
  border-color: ${(props: ActivityTriggerActionEnumStyle = ActivityTriggerActionT.DEFAULT) =>
    props?.borderColor || "none"};
  border-radius: 100px;
  background-color: ${(props: ActivityTriggerActionEnumStyle = ActivityTriggerActionT.DEFAULT) =>
    props?.backgroundColor};
  color: ${(props: ActivityTriggerActionEnumStyle = ActivityTriggerActionT.DEFAULT) => props?.color};
`;

export const TimelineContent = styled(MuiTimelineContent)`
  color: #707070;
  font-size: 11px;
  font-weight: 900;
  height: fit-content;
  margin-left: 22px;
  padding: 0 5px;
  position: absolute;
  top: 2px;
`;

export const TimelineConnector = styled(MuiTimelineConnector)`
  width: 1px;
  &.dot {
    margin-left: 7px;
  }
`;

export const TimelineDot = styled(MuiTimelineDot)<{
  customColor?: string;
  backgroundColor?: string;
  customColor1?: string;
}>`
  align-items: center;
  background-color: ${(props) => props?.backgroundColor || COLORS.primary} !important;
  box-shadow: none;
  color: ${(props) => props?.backgroundColor || COLORS.primary} !important;
  display: flex;
  font-size: 10px;
  font-weight: bold;
  justify-content: center;
  height: 8px;
  margin: 0;
  width: 8px;

  &.pickup.outlined {
    color: ${(props) => props?.backgroundColor || COLORS.primary} !important;
    border-color: ${(props) => props?.customColor || COLORS.primary} !important;
  }

  &.pickup.contained {
    background-color: ${(props) => props?.backgroundColor || COLORS.primary} !important;
    color: ${(props) => props?.customColor1 || COLORS.primary} !important;
  }

  &.delivery.outlined {
    color: #ebae23;
    border-color: #ebae23;
  }

  &.delivery.contained {
    background-color: #ebae23;
  }
  &.done {
    color: #c9c9c9;
    border-color: #c9c9c9;
  }

  &.dot {
    height: 5px;
    margin-left: 7px;
    padding: 0;
    width: 4.5px;
  }
`;
export const StopLabel = {
  [EActionType.Pickup]: "P",
  [EActionType.Delivery]: "D",
  [EActionType.PickupDelivery]: "P/D",
  [EActionType.Unknown]: "S",
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customBadge: {
      backgroundColor: "#fff",
      color: "#f2994a",
      margin: "-2px -16px 0 0",
    },
    vehicleType: {
      marginRight: "15px",
      textAlign: "center",
      [theme.breakpoints.down("xs")]: {
        margin: "3px 10px 3px 17px",
      },
    },
    date: { color: "#757a93", fontWeight: 600, fontSize: 14, marginLeft: 11 },
    time: {
      color: "rgb(47, 128, 237)",
      fontSize: "14px",
      fontWeight: 600,
    },
    AddressPickup: { marginLeft: "10px" },
    icon: {
      marginTop: "auto",
      marginBottom: "auto",
      height: "35px",
      width: "35px",
      borderRadius: "12px",
      background: "rgb(57, 79, 191)",
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      alignItems: "center",
      marginRight: "10px",
    },
    timelineSeparator: {
      display: "flex",
      flexDirection: "row",
    },
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    itemContent: {
      width: "300px",
      height: "70px",
      marginLeft: "10px",
      marginRight: "30px",
      marginBottom: "30px",
      padding: "10px",
      borderRadius: "4px",
      fontSize: "10px",
      border: "solid 1px #d7d9e2",
    },
    itemContentNoContent: {
      width: "300px",
      height: "45px",
      margin: "30px",
      padding: "10px",
      borderRadius: "4px",
    },
    itemContenTop: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    itemAgent: {
      fontSize: "12px",
      marginLeft: "10px",
      fontWeight: 600,
      textAlign: "left",
      color: "#399ebf",
    },
    itemBottomText: {
      fontSize: "10px",
      color: "#757a93",
      marginTop: "15px",
      "& .itemUID": {
        fontWeight: "bold",
      },
    },
    itemActivityDate: {
      fontSize: "11px",
      color: "#757a93",
      fontWeight: 500,
      minWidth: "106px",
      maxWidth: "110px",
      padding: "10px",
      margin: "10px",
    },
  })
);

interface TaskDetailsMADProps {
  isLast?: boolean;
  showItems?: boolean;
  onChangeTodo?: (value: string, stop: StopType) => void;
  primaryColor?: string;
  editMode?: boolean;
  axe?: Axe;
  templateStops?: StopType[];
  shouldShowActions?: boolean;
  isTaskDone?: boolean;
  getNumberOfProductsToPick?: () => number;
  task?: Task;
}

const TaskDetailsMAD = ({ task }: TaskDetailsMADProps) => {
  const styles = useStyles({});
  const { text } = useText();
  return (
    <>
      <div className={styles.timelineSeparator}>
        <div className={styles.itemActivityDate}></div>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot customColor="rgba(112, 112, 112, 0.18)" backgroundColor="#fff"></TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <div className={styles.itemContentNoContent}></div>
        </TimelineItem>
      </div>
      {task.activities?.map((activity) => (
        <div className={styles.timelineSeparator} key={activity?._id}>
          <div className={styles.itemActivityDate}>{format(new Date(activity?.activity_date), "dd/MM/yyyy H:mm")}</div>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot customColor="rgba(112, 112, 112, 0.18)" backgroundColor="#399ebf"></TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <div className={styles.itemContent}>
              <div className={styles.itemContenTop}>
                <DivStatus
                  {...(ActivityTriggerActionT[activity?.activity_trigger_action_data]
                    ? ActivityTriggerActionT[activity?.activity_trigger_action_data]
                    : ActivityTriggerActionT.DEFAULT)}
                >
                  {activity?.activity_trigger_action_data === "UNASSIGNED"
                    ? "CREATED"
                    : activity?.activity_trigger_action_data?.replace(/_/g, " ")}
                </DivStatus>
                <div className={styles.itemAgent}>{`${activity?.activity_updated_by?.first_name || ""} ${
                  activity?.activity_updated_by?.last_name || "N/A"
                }`}</div>
              </div>
              <div className={styles.itemBottomText}>
                {`${text.all.the_task} `} <span className="itemUID">{task?.task_UID}</span> {`${text.all.is} `}
                {activity?.activity_trigger_action_data === "UNASSIGNED"
                  ? "created"
                  : activity?.activity_trigger_action_data?.replace(/_/g, " ")?.toLowerCase()}
              </div>
            </div>
          </TimelineItem>
        </div>
      ))}
    </>
  );
};

TaskDetailsMAD.defaultProps = {
  showItems: true,
};

export default TaskDetailsMAD;
